import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { OracaoProvider } from 'src/app/services/oracao/oracao';


@Component({
  selector: 'app-oracao-pessoas',
  templateUrl: './oracao-pessoas.page.html',
  styleUrls: ['./oracao-pessoas.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
    NomenclaturaPipe
  ],
})
export class OracaoPessoasPage implements OnInit {
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  idOracao: string = '';
  pessoas: any = [];
  isTestemunho: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public oracaoProvider: OracaoProvider,
    private translate: TranslateService
  ) {

    this.idOracao = this.navParams.get('idOracao');
    this.isTestemunho = this.navParams.get('isTestemunho');
    // this.loader.present();

    this.oracaoProvider.getPessoaOrando(this.idOracao).subscribe((data) => {
      this.pessoas = data;
      // this.loader.dismiss();
    });

  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
